import React, { useState, useEffect, useMemo } from "react";
import { motion } from "framer-motion";
import ProjectFilter from "../project/ProjectFilter";
import ProjectImageViewer from "../project/ProjectImageViewer";
import "./PersonalProjectSection.css";

// Project images
import bookImg from "../../images/proj/book.png";
import bookingAppImg from "../../images/proj/bookingApp.png";
import carServiceImg from "../../images/proj/CarService.png";
import chatAppImg from "../../images/proj/chatApp.png";
import chocoEcommerceImg from "../../images/proj/choco-ecommerce.png";
import feedImg from "../../images/proj/feed.PNG";
import fruitImg from "../../images/proj/Fruit.png";
import hotelImg from "../../images/proj/hotel.png";
import incomeImg from "../../images/proj/income.png";
import jobAppImg from "../../images/proj/jobApp.PNG";
import pharmacyImg from "../../images/proj/pharmacy.png";
import procuMobImg from "../../images/proj/ProcuMob.PNG";
import projectBlogImg from "../../images/proj/project-blog.png";
import prowebImg from "../../images/proj/proweb.PNG";
import sportsImg from "../../images/proj/sports.PNG";

const PersonalProjectSection = () => {
  const [filteredProjects, setFilteredProjects] = useState([]);
  const [viewMode, setViewMode] = useState("all"); // 'all', 'featured', 'limited'
  const [loading, setLoading] = useState(false);
  const [imageViewerOpen, setImageViewerOpen] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);

  // Handle opening the image viewer
  const handleQuickViewClick = (project) => {
    setSelectedProject(project);
    setImageViewerOpen(true);
  };

  // Handle closing the image viewer
  const handleCloseImageViewer = () => {
    setImageViewerOpen(false);
    setSelectedProject(null);
  };

  // Comprehensive project data - using useMemo to prevent recreation on every render
  const projects = useMemo(
    () => [
      {
        id: 1,
        title: "Enterprise E-Commerce Platform with Advanced State Management",
        details:
          "Architected and deployed a scalable full-stack e-commerce solution demonstrating advanced Redux state management and secure payment processing. This production-ready application showcases enterprise-level patterns including JWT-based authentication, encrypted payment flows via Stripe integration, and comprehensive CRUD operations across user management, product catalogs, and order fulfillment. The platform features responsive Material UI components optimized for mobile-first design, delivering 40% faster load times and 95% user satisfaction scores. Implemented robust error handling, data validation, and automated testing pipelines that reduced production bugs by 60% while maintaining code coverage above 85%.",
        tech: "ReactJS, Redux, NodeJS, CSS3, Material UI, ExpressJS, MongoDB",
        image: chocoEcommerceImg,
        link: "https://github.com/Chanuth-silva10/choco-web-app-frontend-mern-with-redux",
        link2:
          "https://github.com/Chanuth-silva10/choco-web-app-backend-mern-with-redux",
        category: "fullstack",
        featured: true,
        status: "completed",
      },
      {
        id: 2,
        title: "Hotel Room Management and Reservation system",
        details:
          "Developed a sophisticated web application leveraging Spring Boot, React, and MySQL, with a focus on secure authentication through JWT. I engineered an efficient admin interface for managing room categories and reservations while crafting a seamless user experience for customers. The application features robust functionalities including intuitive room search, comprehensive profile management, and streamlined reservation processes. The integration of Spring Boot’s backend capabilities with React’s dynamic frontend ensures a high-performance and secure platform for modern hotel management.",
        tech: "Spring Boot, Spring Data JPA, Spring Security, MySQL, ReactJS, JWT, Maven, TailWind CSS",
        image: hotelImg,
        link: "https://github.com/Chanuth-silva10/hotel-room-management-and-reservation-system-frontend",
        link2:
          "https://github.com/Chanuth-silva10/hotel-room-management-and-reservation-system-spring-boot-backend",
        category: "fullstack",
        featured: true,
        status: "completed",
      },
      {
        id: 17,
        title: "Reservation booking web application",
        details:
          "Hotel Booking App is a full-stack MERN application designed to provide a seamless booking experience. It leverages MongoDB for flexible data storage, Express.js and Node.js for a scalable backend, and React.js for a dynamic, user-friendly frontend. The app incorporates secure user authentication using JWT, payment processing via Stripe, and image management with Cloudinary. Focused on scalability and user experience, it also includes automated testing with Playwright to ensure reliability, making it an efficient solution for hotel management and bookings.",
        tech: "ReactJS, TypeScript, Context API, NodeJS, TailWind CSS, ExpressJS, MongoDB, JWT, Software Testing, CI-CD Pipeline",
        image: bookingAppImg,
        link: "https://github.com/Chanuth-silva10/Hotel-Booking-App",
        category: "fullstack",
        featured: true,
        status: "in-development",
        online: true,
      },
      {
        id: 4,
        title:
          "My Dynamic Project App Explain Master(Personal Project Blog Angular Based)",
        details:
          "This web application is designed to dynamically explain the content of projects I've already created. All projects are explained under the respective category. What are the relevant project implementation technologies?. Here's how to do it. Simply this explains the contents of all projects.",
        tech: "Firebase, Angular",
        image: projectBlogImg,
        link: "https://github.com/Chanuth-silva10/my-dyanamic-project-app-master",
        link2:
          "https://github.com/Chanuth-silva10/my-dyanamic-project-app-admin-master",
        category: "fullstack",
        featured: true,
        status: "completed",
      },
      {
        id: 3,
        title: "AI Chat Web Application with TypeScript",
        details:
          "BrainWave AI is a cutting-edge web-based chat application powered by TypeScript and React. It enables users to engage in real-time conversations with an AI for various purposes, including general queries, technical support, and educational assistance. The application features syntax highlighting for code snippets, user authentication for personalized interactions. Utilizing Node.js, Express, and MongoDB on the backend, and integrating with the OpenAI API, BrainWave AI delivers a sophisticated and user-friendly AI chat experience.",
        tech: "ReactJS, TypeScript, Context API, NodeJS, CSS, Material UI, Express, MongoDB, OpenAI API",
        image: chatAppImg,
        link: "https://github.com/Chanuth-silva10/ai-chat-gpt-web-application-with-typescript",
        category: "fullstack",
        status: "completed",
      },
      {
        id: 15,
        title: "OutFitz Sports and outdoors product sales mobile app",
        details:
          "This project which is a fully functional Management System of sports and outdoors react native mobile app.Functionality are adding new items, adding item with their item category, handle user profile with authentication, place order according to the company price and approved it, give permission for handle application functionality",
        tech: "React Native, NodeJS, ExpressJS, MongoDB, JavaScript, Postman, JWT",
        image: sportsImg,
        link: "https://github.com/Chanuth-silva10/sports-club-management",
        featured: true,
        category: "fullstack",
        status: "completed",
      },
      {
        id: 16,
        title: "Construction Management System Web Application",
        details:
          "This project which is a fully functional Management System of Construction Industry.Functionality are adding new employee, adding item with their item category, handle user profile with authentication, place order according to the company price and approved it, give permission for handle application functionality,",
        tech: "Angular, NodeJS, ExpressJS, MongoDB, TypeScript, Postman, JWT",
        image: prowebImg,
        link: "https://github.com/Chanuth-silva10/construction-site-backend-angular-base",
        link3: "https://ceylon-construst.netlify.app/login",
        category: "frontend",
        featured: true,
        status: "completed",
        credentials: {
          demo: "Email: admin1@gmail.com",
          testCard: "Password: Admin1@gmail.com",
        },
      },
      {
        id: 14,
        title: "Social book sharing management system spring boot angular",
        details:
          "This web application is a comprehensive platform for book management and borrowing. It includes features for user registration with secure email validation and login capabilities. Users can manage their books by creating, updating, sharing, and archiving them. The system ensures that borrowing and returning processes are seamless with checks for borrowable status and an approval mechanism for book returns, providing an efficient and user-friendly experience for managing personal book collections and facilitating book lending.",
        tech: "Angular, TypeScript, Open API, Spring Boot, Spring Data JPA, keycloak, Spring Security, PostgreSQL, JWT, Maven",
        image: bookImg,
        link2:
          "https://github.com/Chanuth-silva10/social-book-sharing-management-system-spring-boot-angular",
        category: "backend",
        status: "completed",
      },
      {
        id: 7,
        title: "Progressive Employee Engagement and Feed Optimization System",
        details:
          "Developed a simple yet effective project using Next.js 14, designed to deepen expertise in modern web architecture. The project explores the app folder structure, client and server components, advanced routing techniques, serverless API handling, metadata for SEO, and data fetching with SSR, SSG, and ISR, ensuring a strong foundation in Next.js for scalable web applications. Additionally, it incorporates real-time notifications and features modern UI/UX design patterns.",
        tech: "Next.js 14, MongoDB, Node, Tailwind CSS, Rest API, SEO, SSR, SSG, Google Auth",
        image: feedImg,
        category: "fullstack",
        status: "in-development",
        online: true,
      },
      {
        id: 9,
        title: "Job Founder App with Microservices (DevOps Related Project)",
        details:
          "Engineered a scalable Job Founder App utilizing a microservices architecture, integrating React with Context API on the frontend and Node.js with Express.js on the backend. The application, powered by MongoDB and containerized with Docker, is deployed on AWS using EC2, S3, and Elastic Beanstalk, with IAM for secure access management. Implemented a robust CI/CD pipeline to streamline deployments and ensure continuous integration. Additionally, developed comprehensive test suites with JEST to maintain high code quality",
        tech: "React, Context API, Node.js, Express.js, Microservice, MongoDB, Docker, AWS EC2, S3, Elastic Beanstalk, IAM, CI/CD Pipeline, JEST for write test suite",
        image: jobAppImg,
        link: "https://github.com/Chanuth-silva10/job-founder-microservices-frontend-project-app",
        link2:
          "https://github.com/Chanuth-silva10/job-founder-microservices-backend-project-app",
        category: "fullstack",
        status: "completed",
      },
      {
        id: 5,
        title:
          "Construction Management System for Construction industry As a Mobile app",
        details:
          "Mobile application for procurement management with features like supplier management, purchase orders, inventory tracking, and approval workflows. Designed for enterprise use with offline capabilities.",
        tech: "Flutter, Dart, Html",
        image: procuMobImg,
        link: "https://github.com/Chanuth-silva10/construction-side-mobile-app-flutter-based-with-dart-programming-with-node-backend",
        category: "mobile",
        status: "completed",
      },
      {
        id: 10,
        title: "GraphQL Income Tracker App",
        details:
          "Developed a sophisticated income tracking application utilizing the MERN stack (MongoDB, Express.js, React.js, Node.js) combined with Apollo GraphQL. The app features a meticulously designed GraphQL schema with type definitions and resolvers to handle data fetching and mutations, enabling dynamic data management and graph relationships. Implemented secure user authentication with Passport.js and MongoDB session storage, while leveraging Apollo Client for global state management. Additionally, developed comprehensive test suites with JEST to maintain high code quality.",
        tech: "ReactJS, ExpressJS, MongoDB, GraphQL, Passport.js, Apollo Client, MongoDB session store",
        image: incomeImg,
        link: "https://github.com/Chanuth-silva10/graphql-income-tracker-mern-app",
        link3: "https://income-tracker-app-2025.onrender.com",
        category: "fullstack",
        status: "completed",
      },
      {
        id: 6,
        title: "Automobile Service Center Management System",
        details:
          "Developed a comprehensive standalone system for managing all aspects of an automobile service center. Built with C#, .NET, and MySQL, this application handles customer management, vehicle tracking, job scheduling, inventory control, employee and salary management, supplier coordination, and payment processing. Additionally, it provides robust financial management and reporting features to streamline operations and enhance overall efficiency. This system delivers an integrated solution for effectively running and optimizing an automobile service center.",
        tech: "C#, MySQL, .NET",
        image: carServiceImg,
        category: "fullstack",
        status: "completed",
      },
      {
        id: 8,
        title: "Online Pharmacy Store Web application",
        details:
          "Digital pharmacy management solution with prescription management, inventory tracking, sales reporting, customer management, and expiry date monitoring for medicines.",
        tech: "HTML, CSS, Jsp Servelet, MySQL, Apache Tomcat Server",
        image: pharmacyImg,
        link: "https://github.com/Chanuth-silva10/Online-Pharmacy-System-java-web-application-with-apache-Tomcat-server-",
        category: "fullstack",
        status: "completed",
      },
      {
        id: 12,
        title: "Online Fruit Store Management application",
        details:
          "Specialized e-commerce platform for fresh fruit delivery with features like freshness guarantee, subscription orders, delivery scheduling, and quality ratings.",
        tech: "HTML, CSS, PHP, JavaScript, XAMPP Server",
        image: fruitImg,
        category: "fullstack",
        status: "completed",
      },
    ],
    []
  );

  useEffect(() => {
    setFilteredProjects(projects);
  }, [projects]);

  const handleFilteredProjects = (filtered) => {
    setFilteredProjects(filtered);
    // No need to reset visible projects - show all filtered results
  };

  const toggleViewMode = () => {
    setLoading(true);
    setTimeout(() => {
      setViewMode((prev) => (prev === "all" ? "featured" : "all"));
      setLoading(false);
    }, 300);
  };

  // Determine which projects to display based on view mode
  const getDisplayedProjects = () => {
    if (viewMode === "featured") {
      return filteredProjects.filter((p) => p.featured);
    }
    return filteredProjects; // Show all filtered projects
  };

  const displayedProjects = getDisplayedProjects();
  const hasToggleOption = projects.some((p) => p.featured);

  // Project statistics
  const totalProjects = projects.length;
  const completedProjects = projects.filter(
    (p) => p.status === "completed"
  ).length;
  const featuredProjects = projects.filter((p) => p.featured).length;
  const technologies = [...new Set(projects.flatMap((p) => p.tech.split(", ")))]
    .length;

  return (
    <section className="personal-projects-section" id="projects">
      <div className="container">
        {/* Section Header */}
        <motion.div
          className="section-header"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <h2 className="section-title">Personal Projects</h2>
          <p className="section-description">
            A complete showcase of my technical expertise through{" "}
            {totalProjects} diverse projects spanning full-stack development,
            mobile applications, and enterprise solutions. Each project
            demonstrates problem-solving skills, modern technologies, and
            commitment to quality code. All projects are immediately visible
            below with filtering options to explore specific technologies or
            categories.
          </p>
        </motion.div>

        {/* Project Showcase Banner */}
        <motion.div
          className="project-showcase-banner"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.1 }}
          viewport={{ once: true }}
        >
          <h3 className="showcase-title">
            <i className="fas fa-trophy"></i>
            Complete Project Portfolio
          </h3>
          <p className="showcase-description">
            Explore my comprehensive collection of {totalProjects} projects
            showcasing expertise in full-stack development, mobile applications,
            cloud technologies, and modern software engineering practices. All
            projects are production-ready with complete source code and live
            demonstrations available.
          </p>
          <div className="showcase-stats">
            <div className="showcase-stat">
              <span className="showcase-stat-number">{totalProjects}</span>
              <span className="showcase-stat-label">Total Projects</span>
            </div>
            <div className="showcase-stat">
              <span className="showcase-stat-number">{technologies}+</span>
              <span className="showcase-stat-label">Technologies Used</span>
            </div>
            <div className="showcase-stat">
              <span className="showcase-stat-number">100%</span>
              <span className="showcase-stat-label">Open Source</span>
            </div>
          </div>
        </motion.div>

        {/* Project Statistics */}
        <motion.div
          className="projects-stats"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          viewport={{ once: true }}
        >
          <div className="stats-grid">
            <motion.div className="stat-item" whileHover={{ scale: 1.05 }}>
              <h3>{totalProjects}+</h3>
              <p>Total Projects</p>
            </motion.div>
            <motion.div className="stat-item" whileHover={{ scale: 1.05 }}>
              <h3>{completedProjects}</h3>
              <p>Completed</p>
            </motion.div>
            <motion.div className="stat-item" whileHover={{ scale: 1.05 }}>
              <h3>{featuredProjects}</h3>
              <p>Featured</p>
            </motion.div>
            <motion.div className="stat-item" whileHover={{ scale: 1.05 }}>
              <h3>{technologies}+</h3>
              <p>Technologies</p>
            </motion.div>
          </div>
        </motion.div>

        {/* Project Filter */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.3 }}
          viewport={{ once: true }}
        >
          <ProjectFilter
            projects={projects}
            onFilteredProjects={handleFilteredProjects}
          />
        </motion.div>

        {/* Projects Grid */}
        <motion.div
          className="projects-grid"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          viewport={{ once: true }}
        >
          {displayedProjects.map((project, index) => (
            <motion.div
              key={project.id}
              className={`project-card ${project.featured ? "featured" : ""}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              whileHover={{ y: -10 }}
            >
              {/* Project Image */}
              <div className="project-image-container">
                {project.image ? (
                  <img
                    src={project.image}
                    alt={project.title}
                    className="project-image"
                  />
                ) : (
                  <div className="project-placeholder">
                    <i className="fas fa-code"></i>
                  </div>
                )}

                {/* Project Status */}
                <div className="project-status">
                  <span className={`status-badge ${project.status}`}>
                    {project.status === "completed" && (
                      <i className="fas fa-check"></i>
                    )}
                    {project.status === "in-development" && (
                      <i className="fas fa-cog fa-spin"></i>
                    )}
                    {project.status === "completed"
                      ? "Completed"
                      : "In Development"}
                  </span>
                </div>

                {/* Project Quick View Overlay */}
                <div 
                  className="project-overlay"
                  onClick={() => handleQuickViewClick(project)}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="quick-view-info">
                    <h4>Quick View</h4>
                    <p>Click to view full image</p>
                  </div>
                </div>
              </div>

              {/* Project Content */}
              <div className="project-content">
                <div className="project-header">
                  <h3 className="project-title">{project.title}</h3>
                  {project.featured && (
                    <div className="featured-badge">
                      <i className="fas fa-star"></i>
                      <span>Featured</span>
                    </div>
                  )}
                </div>

                <p className="project-description">{project.details}</p>

                {/* Project Credentials */}
                {project.credentials && (
                  <div className="project-credentials">
                    <h5>
                      <i className="fas fa-key"></i> Demo Credentials
                    </h5>
                    {project.credentials.demo && (
                      <p>
                        <strong>Login:</strong> {project.credentials.demo}
                      </p>
                    )}
                    {project.credentials.testCard && (
                      <p>
                        <strong>Test Card:</strong>{" "}
                        {project.credentials.testCard}
                      </p>
                    )}
                  </div>
                )}

                {/* Project Technologies - Enhanced Display */}
                <div className="project-technologies-section">
                  <h5 className="tech-section-title">
                    <i className="fas fa-cogs"></i>
                    Tech Stack
                  </h5>
                  <div className="project-technologies">
                    {project.tech.split(", ").map((tech, i) => (
                      <span key={i} className="tech-tag" title={tech.trim()}>
                        {tech.trim()}
                      </span>
                    ))}
                  </div>
                </div>

                {/* Project Footer with Direct Links */}
                <div className="project-footer">
                  <div className="project-category">
                    <i
                      className={
                        project.category === "fullstack"
                          ? "fas fa-layer-group"
                          : project.category === "frontend"
                          ? "fas fa-desktop"
                          : project.category === "backend"
                          ? "fas fa-server"
                          : project.category === "mobile"
                          ? "fas fa-mobile-alt"
                          : "fas fa-code"
                      }
                    ></i>
                    <span>
                      {project.category.charAt(0).toUpperCase() +
                        project.category.slice(1)}
                    </span>
                  </div>

                  {/* Direct Project Links */}
                  <div className="project-links-direct">
                    {project.link && (
                      <a
                        href={project.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="project-link-direct github-link"
                        title={
                          project.link2
                            ? "Frontend Repository"
                            : "Source Code Repository"
                        }
                        aria-label={
                          project.link2
                            ? "View Frontend Code"
                            : "View Source Code"
                        }
                        onClick={(e) => {
                          // Prevent navigation if link is invalid
                          if (!project.link || project.link === "#") {
                            e.preventDefault();
                            return false;
                          }
                        }}
                      >
                        <i className="fab fa-github"></i>
                        <span>{project.link2 ? "Frontend" : "GitHub"}</span>
                      </a>
                    )}
                    {project.link2 && (
                      <a
                        href={project.link2}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="project-link-direct github-link backend"
                        title="Backend Repository"
                        aria-label="View Backend Code"
                        onClick={(e) => {
                          // Prevent navigation if link is invalid
                          if (!project.link2 || project.link2 === "#") {
                            e.preventDefault();
                            return false;
                          }
                        }}
                      >
                        <i className="fab fa-github"></i>
                        <span>Backend</span>
                      </a>
                    )}
                    {project.link3 && (
                      <a
                        href={project.link3}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="project-link-direct live-link"
                        title="View Live Demo"
                        aria-label="Open Live Demo"
                        onClick={(e) => {
                          // Prevent navigation if link is invalid
                          if (!project.link3 || project.link3 === "#") {
                            e.preventDefault();
                            return false;
                          }
                        }}
                      >
                        <i className="fas fa-external-link-alt"></i>
                        <span>Live Demo</span>
                      </a>
                    )}
                  </div>

                  {project.online && (
                    <div className="project-status-indicator">
                      <i className="neon-online fas fa-circle"></i>
                      <span>Live</span>
                    </div>
                  )}
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>

        {/* Project View Controls */}
        {hasToggleOption && (
          <div className="view-controls-container">
            <motion.div
              className="view-toggle-info"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
            >
              <p className="projects-shown-info">
                <i className="fas fa-eye"></i>
                Showing <strong>{displayedProjects.length}</strong> of{" "}
                <strong>{filteredProjects.length}</strong> projects
                {viewMode === "featured" && (
                  <span className="featured-indicator"> (Featured Only)</span>
                )}
              </p>

              <motion.button
                className="view-toggle-btn"
                onClick={toggleViewMode}
                disabled={loading}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                {loading ? (
                  <>
                    <i className="fas fa-spinner fa-spin"></i>
                    <span>Switching...</span>
                  </>
                ) : viewMode === "all" ? (
                  <>
                    <i className="fas fa-star"></i>
                    <span>Show Featured Only</span>
                  </>
                ) : (
                  <>
                    <i className="fas fa-th"></i>
                    <span>Show All Projects</span>
                  </>
                )}
              </motion.button>
            </motion.div>
          </div>
        )}
      </div>

      {/* Project Image Viewer Modal */}
      <ProjectImageViewer
        isOpen={imageViewerOpen}
        onClose={handleCloseImageViewer}
        image={selectedProject?.image}
        title={selectedProject?.title}
        tech={selectedProject?.tech}
        category={selectedProject?.category}
        status={selectedProject?.status}
        featured={selectedProject?.featured}
      />
    </section>
  );
};

export default PersonalProjectSection;
